var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _g, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _g2, _path153, _path154, _path155, _path156, _path157, _path158, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 228,
    viewBox: "0 0 306 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.652 199.93H0.321777V200.083H305.652V199.93Z",
    fill: "#B3CCE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.088 204.089H177.541V204.241H193.088V204.089Z",
    fill: "#B3CCE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M278.441 207.392H241.6V207.545H278.441V207.392Z",
    fill: "#B3CCE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.231 204.162H136.169V204.315H174.231V204.162Z",
    fill: "#B3CCE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.486 208.73H103.523V208.883H111.486V208.73Z",
    fill: "#B3CCE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.485 208.73H119.224V208.883H155.485V208.73Z",
    fill: "#B3CCE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8368 206.153H32.3569V206.305H55.8368V206.153Z",
    fill: "#B3CCE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.048 172.695H27.136C26.2123 172.693 25.327 172.325 24.6744 171.671C24.0218 171.018 23.6553 170.132 23.6553 169.208V3.45634C23.6633 2.53792 24.0334 1.65976 24.6851 1.01261C25.3368 0.365455 26.2176 0.0015733 27.136 0H145.048C145.973 0 146.86 0.367366 147.514 1.02128C148.168 1.6752 148.535 2.56209 148.535 3.48687V169.208C148.535 170.133 148.168 171.02 147.514 171.673C146.86 172.327 145.973 172.695 145.048 172.695ZM27.136 0.122133C26.2528 0.12375 25.4063 0.475744 24.7823 1.10085C24.1584 1.72596 23.8079 2.57311 23.8079 3.45634V169.208C23.8079 170.091 24.1584 170.938 24.7823 171.563C25.4063 172.188 26.2528 172.54 27.136 172.542H145.048C145.932 172.54 146.779 172.189 147.404 171.564C148.029 170.939 148.381 170.092 148.383 169.208V3.45634C148.381 2.57255 148.029 1.72542 147.404 1.10048C146.779 0.475546 145.932 0.123747 145.048 0.122133H27.136Z",
    fill: "#B3CCE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M277.14 172.695H159.222C158.297 172.693 157.412 172.325 156.758 171.672C156.104 171.018 155.736 170.132 155.735 169.208V3.45634C155.745 2.53736 156.116 1.65921 156.769 1.01223C157.421 0.365241 158.303 0.00155614 159.222 0H277.14C278.058 0.00317818 278.937 0.36777 279.587 1.01475C280.238 1.66173 280.607 2.53897 280.615 3.45634V169.208C280.615 170.131 280.249 171.016 279.598 171.669C278.947 172.323 278.063 172.692 277.14 172.695ZM159.222 0.122133C158.338 0.123747 157.491 0.475546 156.866 1.10048C156.241 1.72542 155.889 2.57255 155.888 3.45634V169.208C155.889 170.092 156.241 170.939 156.866 171.564C157.491 172.189 158.338 172.54 159.222 172.542H277.14C278.024 172.54 278.871 172.189 279.496 171.564C280.121 170.939 280.473 170.092 280.474 169.208V3.45634C280.473 2.57255 280.121 1.72542 279.496 1.10048C278.871 0.475546 278.024 0.123747 277.14 0.122133H159.222Z",
    fill: "#B3CCE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.948 16.958H54.4629V55.0938H163.948V16.958Z",
    fill: "#F2F9FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M161.866 53.0114V19.0404L56.5452 19.0404V53.0114L161.866 53.0114Z",
    fill: "#B2C7DC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3236 17.3855H90.2412V54.6602H92.3236V17.3855Z",
    fill: "#F2F9FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7058 53.0054H90.2412V19.0343H78.7058V53.0054Z",
    fill: "#C9DDF1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M114.472 53.0052H126.008V19.0342H114.472V53.0052Z",
    fill: "#C9DDF1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M150.33 53.0052H161.866V19.0342H150.33V53.0052Z",
    fill: "#C9DDF1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128.097 17.3855H126.014V54.6602H128.097V17.3855Z",
    fill: "#F2F9FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0939 55.0876H54.4629L54.4629 16.9519H44.0939L44.0939 55.0876Z",
    fill: "#B2C7DC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0907 53.0115H63.8916L68.3983 24.0417H87.5974L83.0907 53.0115Z",
    fill: "#B3CCE5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.61 53.0115H101.411L104.745 24.0417H123.944L120.61 53.0115Z",
    fill: "#DCEAF8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.438 53.0114H93.9727L101.319 26.6614H118.784L111.438 53.0114Z",
    fill: "#C9DDF1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7441 21.7029H56.5449V53.0114H75.7441V21.7029Z",
    fill: "#DCEAF8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M157.658 21.7029H138.459V53.0114H157.658V21.7029Z",
    fill: "#DCEAF8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M144.065 53.0114H129.189L134.362 26.6614H149.237L144.065 53.0114Z",
    fill: "#C9DDF1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M136.658 53.0114H128.096V28.5728H144.84L136.658 53.0114Z",
    fill: "#DCEAF8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M157.658 21.7029H153.286V53.0114H157.658V21.7029Z",
    fill: "#B3CCE5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2117 50.6848C70.0595 50.6848 69.9135 50.6243 69.8059 50.5167C69.6982 50.409 69.6377 50.263 69.6377 50.1108V24.6218C69.6369 24.5459 69.6512 24.4706 69.6797 24.4003C69.7081 24.3299 69.7503 24.2659 69.8037 24.212C69.8571 24.158 69.9206 24.1152 69.9907 24.086C70.0607 24.0567 70.1358 24.0417 70.2117 24.0417C70.2907 24.0366 70.3698 24.048 70.4441 24.0749C70.5185 24.1019 70.5865 24.1439 70.6438 24.1984C70.7011 24.2529 70.7466 24.3186 70.7773 24.3914C70.8081 24.4643 70.8234 24.5427 70.8224 24.6218V50.0742C70.8278 50.1557 70.8157 50.2375 70.7869 50.3141C70.7581 50.3906 70.7133 50.4601 70.6555 50.5179C70.5977 50.5758 70.5282 50.6206 70.4517 50.6493C70.3751 50.6781 70.2933 50.6902 70.2117 50.6848Z",
    fill: "#F2F9FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M199.8 55.0938H90.3149V93.2295H199.8V55.0938Z",
    fill: "#F2F9FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M197.724 91.1472V57.1761L92.4031 57.1761V91.1472H197.724Z",
    fill: "#B2C7DC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M128.176 55.5212H126.093V92.796H128.176V55.5212Z",
    fill: "#F2F9FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M114.558 91.141H126.093V57.17H114.558V91.141Z",
    fill: "#C9DDF1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M150.324 91.1411H161.86V57.1701H150.324V91.1411Z",
    fill: "#C9DDF1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M186.182 91.141H197.717V57.17H186.182V91.141Z",
    fill: "#C9DDF1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M163.954 55.5212H161.872V92.796H163.954V55.5212Z",
    fill: "#F2F9FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9459 93.2234H90.3149V55.0877H79.9459V93.2234Z",
    fill: "#B2C7DC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M154.642 91.1411H135.442L139.955 62.1714H159.148L154.642 91.1411Z",
    fill: "#B3CCE5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M192.32 91.1411H173.121L176.455 62.1714H195.654L192.32 91.1411Z",
    fill: "#DCEAF8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M183.141 91.141H165.683L173.029 64.791H190.494L183.141 91.141Z",
    fill: "#C9DDF1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M147.295 59.8325H128.096V91.1411H147.295V59.8325Z",
    fill: "#DCEAF8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M121.959 59.8325H102.76V91.1411H121.959V59.8325Z",
    fill: "#DCEAF8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M108.366 91.141H93.4839L98.6562 64.791H113.538L108.366 91.141Z",
    fill: "#C9DDF1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M100.958 91.141H92.397V66.7085H109.135L100.958 91.141Z",
    fill: "#DCEAF8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M121.959 59.8325H117.587V91.1411H121.959V59.8325Z",
    fill: "#B3CCE5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M141.769 88.8023C141.693 88.8031 141.617 88.7887 141.546 88.7598C141.475 88.7309 141.411 88.6882 141.357 88.6342C141.303 88.5802 141.26 88.5159 141.231 88.4451C141.203 88.3744 141.188 88.2986 141.189 88.2222V62.7515C141.196 62.6 141.26 62.4568 141.367 62.3495C141.474 62.2423 141.618 62.1788 141.769 62.1714C141.92 62.1803 142.061 62.2444 142.167 62.3515C142.273 62.4586 142.336 62.601 142.343 62.7515V88.2222C142.344 88.2981 142.33 88.3734 142.301 88.4437C142.273 88.5141 142.231 88.5781 142.177 88.632C142.124 88.686 142.06 88.7288 141.99 88.758C141.92 88.7872 141.845 88.8023 141.769 88.8023Z",
    fill: "#F2F9FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M171.771 38.606V46.4102C171.785 48.7109 172.707 50.913 174.335 52.5388C175.963 54.1645 178.166 55.0826 180.467 55.0938C182.773 55.0906 184.984 54.1761 186.619 52.5495C188.253 50.9229 189.179 48.7162 189.193 46.4102V38.606H171.771Z",
    fill: "#B3CCE5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M117.122 141.905H62.6821V148.25H117.122V141.905Z",
    fill: "#B2C7DC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M117.123 148.25H66.2979V189.805H117.123V148.25Z",
    fill: "#B3CCE5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M117.123 189.805L239.676 189.805V148.25H117.123V189.805Z",
    fill: "#DCEAF8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2972 150.601L239.676 150.601V148.256L66.2972 148.256V150.601Z",
    fill: "#C9DDF1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M117.123 148.25L243.292 148.25V141.905L117.123 141.905V148.25Z",
    fill: "#F2F9FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2979 189.805V199.93L76.4226 189.805H66.2979Z",
    fill: "#B3CCE5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M117.123 189.805V199.93L127.248 189.805H117.123Z",
    fill: "#DCEAF8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M239.676 189.805V199.93L229.551 189.805H239.676Z",
    fill: "#DCEAF8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M117.123 189.805V199.93L106.998 189.805H117.123Z",
    fill: "#B3CCE5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M188.851 189.805V199.93L178.726 189.805H188.851Z",
    fill: "#C9DDF1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M188.851 189.805V199.93L198.975 189.805H188.851Z",
    fill: "#C9DDF1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M149.988 119.402L146.294 140.366H130.313L129.745 141.905H146.019H155.973H183.007L186.976 119.402H149.988Z",
    fill: "#C9DDF1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M260.616 29.0674H217.405V100.515H260.616V29.0674Z",
    fill: "#C9DDF1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M261.941 29.0674H218.73V100.515H261.941V29.0674Z",
    fill: "#F2F9FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M240.47 79.6057H236.61L240.195 49.9825H244.054L240.47 79.6057Z",
    fill: "#B3CCE5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M250.68 79.6057H246.821L250.405 49.9825H254.265L250.68 79.6057Z",
    fill: "#B3CCE5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M230.266 79.6057H226.406L229.991 49.9825H233.85L230.266 79.6057Z",
    fill: "#B3CCE5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M152.987 227.508C218.378 227.508 271.388 224.413 271.388 220.595C271.388 216.777 218.378 213.682 152.987 213.682C87.5958 213.682 34.5859 216.777 34.5859 220.595C34.5859 224.413 87.5958 227.508 152.987 227.508Z",
    fill: "#DCEAF8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0537 214.885H95.5909L95.7863 204.376H91.2491L91.0537 214.885Z",
    fill: "#B55B52"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8184 214.885H68.3556L70.3768 204.376H65.8396L63.8184 214.885Z",
    fill: "#B55B52"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6609 214.342H63.568C63.4791 214.34 63.3924 214.37 63.3232 214.426C63.254 214.481 63.2066 214.56 63.1894 214.647L62.3894 218.684C62.3714 218.783 62.3756 218.885 62.4018 218.983C62.4279 219.081 62.4754 219.171 62.5408 219.248C62.6063 219.325 62.6879 219.387 62.78 219.429C62.8721 219.47 62.9723 219.491 63.0734 219.49C64.8504 219.49 65.7114 219.355 67.9586 219.355C69.3387 219.355 72.1844 219.496 74.0653 219.496C75.9461 219.496 76.172 217.615 75.3843 217.444C71.873 216.681 70.499 215.612 69.3876 214.617C69.1847 214.443 68.9277 214.346 68.6609 214.342Z",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5485 214.342H90.5961C90.5072 214.34 90.4205 214.37 90.3513 214.425C90.282 214.481 90.2347 214.56 90.2175 214.647L89.4175 218.683C89.3985 218.782 89.4017 218.884 89.4267 218.981C89.4518 219.078 89.4981 219.168 89.5624 219.246C89.6267 219.323 89.7073 219.385 89.7984 219.427C89.8895 219.469 89.9888 219.49 90.0892 219.489C91.8785 219.489 94.4555 219.355 96.7027 219.355C99.3285 219.355 99.6033 219.496 102.687 219.496C104.55 219.496 105.02 217.615 104.232 217.444C100.666 216.668 99.7621 216.583 96.6477 214.696C96.3213 214.478 95.9407 214.355 95.5485 214.342Z",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3638 71.3922L100.556 69.4076C100.556 69.4076 106.949 84.2222 109.105 85.1443C112.024 86.3656 116.097 90.3532 118.986 92.7653C119.083 93.5287 118.723 95.5377 118.271 96.0629C113.044 94.8416 106.54 91.8494 104.403 89.8769C99.5361 85.3764 94.3638 71.3922 94.3638 71.3922Z",
    fill: "#B55B52"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9225 67.9848C91.1821 71.9541 98.1681 84.5581 98.1681 84.5581L107.426 80.2835C106.286 76.4418 104.749 72.7293 102.84 69.2061C99.9268 64.1193 94.8339 63.6247 92.9225 67.9848Z",
    fill: "url(#paint0_linear_1660_3857)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M101.631 77.45C99.6093 74.6593 96.3301 73.8715 93.4111 73.725C94.9256 78.7141 98.1743 84.5581 98.1743 84.5581L103.456 82.1154C103.28 80.424 102.649 78.8119 101.631 77.45Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M118.363 92.3257L123.755 93.1867L122.362 98.8842C120.473 98.0768 118.719 96.9854 117.16 95.6477L118.363 92.3257Z",
    fill: "#B55B52"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M128.432 95.5988L126.46 98.7375L122.362 98.8841L123.755 93.1866L128.432 95.5988Z",
    fill: "#B55B52"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M95.786 204.382L95.6822 209.798H91.145L91.2488 204.382H95.786Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.8338 204.382H70.3771L69.3329 209.798H64.7896L65.8338 204.382Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M98.852 65.4078C98.852 65.4078 103.872 79.6362 100.073 106.511H75.8118C75.5553 102.786 77.4483 82.7261 73.4302 65.1757C76.1079 64.6562 78.817 64.3135 81.5397 64.1498C84.9749 63.9512 88.4186 63.9512 91.8538 64.1498C94.2152 64.3899 96.5548 64.8105 98.852 65.4078Z",
    fill: "url(#paint1_linear_1660_3857)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.9211 82.1459H80.9107L80.752 77.7308H87.7623L87.9211 82.1459Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M88.086 81.9688H81.0756L80.752 77.7308H87.7623L88.086 81.9688Z",
    fill: "#263238"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4693 80.3506H81.5579L81.4053 78.4331H83.3227L83.4693 80.3506Z",
    fill: "url(#paint2_linear_1660_3857)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3653 79.3614H83.9212L83.8906 78.9828H87.3347L87.3653 79.3614Z",
    fill: "#C9DDF1"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6996 80.1064H83.9822L83.9517 79.7217H86.6691L86.6996 80.1064Z",
    fill: "#C9DDF1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5366 81.1994H81.6192L81.5947 80.8147H83.5061L83.5366 81.1994Z",
    fill: "#C9DDF1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0615 81.1994H87.5057L87.4751 80.8147H84.0371L84.0615 81.1994Z",
    fill: "#C9DDF1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3243 78.5186C84.2236 78.5174 84.127 78.4785 84.0535 78.4095C83.98 78.3406 83.935 78.2466 83.9274 78.1461L83.8602 77.3095C83.8569 77.2623 83.8632 77.2149 83.8789 77.1702C83.8945 77.1255 83.919 77.0845 83.951 77.0496C83.983 77.0148 84.0218 76.9868 84.065 76.9674C84.1082 76.9481 84.1549 76.9377 84.2022 76.937C84.303 76.9382 84.3996 76.9772 84.4731 77.0461C84.5465 77.1151 84.5915 77.209 84.5991 77.3095L84.6663 78.1461C84.6715 78.1937 84.6665 78.2419 84.6516 78.2874C84.6367 78.3329 84.6123 78.3747 84.5799 78.41C84.5475 78.4453 84.5079 78.4732 84.4639 78.4919C84.4198 78.5107 84.3722 78.5198 84.3243 78.5186Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M78.8043 69.5114C79.2806 72.3998 78.5417 79.282 75.983 87.2938C75.8593 80.4526 75.1318 73.6356 73.8091 66.9222V66.8856C75.4334 66.7268 78.3524 66.8001 78.8043 69.5114Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6392 54.5015C83.372 57.8235 83.7934 61.9332 81.5278 64.1499C81.5278 64.1499 82.9446 67.5146 89.1122 67.5146C94.7425 67.5146 91.8419 64.1499 91.8419 64.1499C88.1169 63.2644 88.1779 58.6906 88.7886 56.1136L82.6392 54.5015Z",
    fill: "#B55B52"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1057 66.9222L90.8827 68.8947L90.4308 70.2748C90.3947 70.3852 90.3255 70.4819 90.2327 70.5517C90.1399 70.6216 90.0279 70.6614 89.9118 70.6656L88.6904 70.7267C88.5905 70.7292 88.4914 70.7071 88.402 70.6624C88.3125 70.6177 88.2355 70.5517 88.1775 70.4702L87.2065 69.0412L89.1057 66.9222Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1058 66.9222C88.3335 68.146 87.6498 69.4235 87.0601 70.745C87.0601 70.745 79.6589 68.1252 79.9276 64.1376C80.7297 63.7494 81.5031 63.3046 82.2419 62.8064C82.2419 62.8064 82.5656 65.3406 89.1058 66.9222Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1055 66.9222C90.0304 67.9914 90.803 69.1833 91.4015 70.4641C92.2252 69.662 92.8099 68.6469 93.0902 67.532C93.3706 66.417 93.3356 65.2461 92.9893 64.1498C92.3429 63.894 91.6772 63.6898 90.9985 63.5392C90.9985 63.5392 91.5176 66.0673 89.1055 66.9222Z",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7716 69.9938C89.9548 69.9205 92.9897 85.4008 93.4355 89.193C94.321 94.2431 91.9455 99.8185 91.9394 99.8062C90.7067 96.2989 89.9728 92.6358 89.7593 88.9243C89.4113 82.4757 89.2586 73.7127 88.6724 69.9938H89.7716Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.7824 56.1136C88.3276 57.9087 88.3826 59.7951 88.9412 61.5607C88.3637 61.474 87.8021 61.3032 87.2741 61.0538C85.1673 60.0707 84.0986 58.5257 82.9994 56.2235C82.9017 55.6129 82.7857 55.0633 82.6636 54.5015L88.7824 56.1136Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0889 44.4438L91.7682 49.836C92.1544 49.4146 92.4233 48.8993 92.5481 48.3414C92.6728 47.7836 92.649 47.2028 92.479 46.657C92.3091 46.1113 91.9989 45.6197 91.5794 45.2313C91.16 44.8429 90.6461 44.5714 90.0889 44.4438Z",
    fill: "#263238"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M79.848 50.4588C81.1548 54.8067 81.68 57.4204 84.4463 59.2035C88.5621 61.8843 93.4596 58.6966 93.4535 54.0678C93.4535 49.9031 91.3101 43.4912 86.6264 42.6607C85.6006 42.4727 84.5436 42.5552 83.5594 42.9C82.5753 43.2448 81.6979 43.8401 81.0138 44.6271C80.3297 45.4142 79.8624 46.3659 79.658 47.3885C79.4535 48.4111 79.519 49.4693 79.848 50.4588Z",
    fill: "#B55B52"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6133 53.738C82.8346 52.9442 83.3414 48.8528 82.2239 47.4238C86.1383 47.2467 88.074 45.9216 88.1779 45.2071C89.5518 45.8178 92.9838 46.0498 92.5502 44.3156C92.3513 43.6197 91.9586 42.9948 91.418 42.5136C90.8774 42.0325 90.2111 41.715 89.4969 41.5981C88.1473 40.1692 84.7643 38.9723 82.3766 40.9081C78.1997 40.9081 75.9891 44.2667 77.1554 45.5918C76.6627 45.8805 76.254 46.293 75.97 46.7885C75.686 47.2839 75.5366 47.8451 75.5366 48.4161C75.5366 48.9872 75.686 49.5484 75.97 50.0438C76.254 50.5393 76.6627 50.9518 77.1554 51.2404C76.044 52.9259 80.8744 56.6814 81.6133 53.738Z",
    fill: "#263238"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0299 55.7471C79.4289 56.1524 79.904 56.4749 80.428 56.696C80.952 56.9171 81.5145 57.0326 82.0832 57.0356C83.5793 57.0356 83.9152 55.6006 83.1274 54.3915C82.4313 53.2984 80.813 51.9794 79.4635 52.5595C78.1139 53.1396 78.0468 54.7396 79.0299 55.7471Z",
    fill: "#B55B52"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1289 106.511C84.1289 106.511 84.6113 112.215 85.2281 119.946C85.9242 128.709 86.7853 140.098 87.3043 148.751C87.3043 148.8 87.3043 148.836 87.3043 148.873C87.402 150.516 87.4875 152.061 87.5547 153.471C88.2448 167.608 89.6615 208.748 89.6615 208.748H97.3436C97.3436 208.748 101.215 166.765 101.374 152.378C101.533 138.54 100.073 106.511 100.073 106.511H84.1289Z",
    fill: "#263238"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0995 206.403C89.0629 206.403 89.1606 208.913 89.1606 208.913H98.0274L98.3266 206.092L89.0995 206.403Z",
    fill: "url(#paint3_linear_1660_3857)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.2036 119.946C85.8998 128.709 86.7608 140.098 87.2799 148.751C87.2799 148.8 87.2799 148.836 87.2799 148.873C89.1607 140.653 89.9179 130.431 89.6553 113.601L85.2036 119.946Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4689 106.511C91.4689 106.511 87.1943 139.292 84.6662 152.311C81.9182 166.533 71.4209 208.779 71.4209 208.779H63.1099C63.1099 208.779 69.6683 167.681 71.0851 153.599C72.63 138.333 75.8116 106.542 75.8116 106.542L91.4689 106.511Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0554 206.58L62.7012 208.901H71.8305L72.5755 206.238L63.0554 206.58Z",
    fill: "url(#paint4_linear_1660_3857)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7427 50.2512C86.8282 50.6115 87.0846 50.8619 87.3167 50.813C87.5487 50.7642 87.6709 50.4283 87.5854 50.0741C87.4999 49.7199 87.2434 49.4635 87.0114 49.5123C86.7793 49.5612 86.6633 49.897 86.7427 50.2512Z",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7548 49.384C90.8402 49.7382 91.0967 49.9947 91.3288 49.9397C91.5608 49.8848 91.6769 49.5611 91.5975 49.2008C91.5181 48.8405 91.2555 48.5902 91.0234 48.639C90.7914 48.6879 90.6998 49.0237 90.7548 49.384Z",
    fill: "#263238"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M89.521 49.8359C90.2105 50.8429 91.0321 51.7527 91.9636 52.5412C91.7617 52.7686 91.5118 52.9485 91.232 53.0678C90.9521 53.1871 90.6494 53.2429 90.3454 53.2312L89.521 49.8359Z",
    fill: "#A02724"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6553 54.6236C89.6826 54.6151 89.7055 54.5963 89.7192 54.5712C89.7329 54.5462 89.7362 54.5167 89.7286 54.4892C89.7251 54.4759 89.7189 54.4635 89.7106 54.4526C89.7022 54.4417 89.6917 54.4326 89.6798 54.4258C89.6679 54.419 89.6547 54.4146 89.6411 54.4129C89.6274 54.4112 89.6136 54.4122 89.6004 54.4159C89.1596 54.5325 88.6977 54.5446 88.2514 54.4513C87.8051 54.358 87.3867 54.1619 87.0295 53.8785C87.0198 53.868 87.008 53.8596 86.9948 53.8538C86.9817 53.8481 86.9675 53.8451 86.9532 53.8451C86.9388 53.8451 86.9246 53.8481 86.9115 53.8538C86.8984 53.8596 86.8866 53.868 86.8768 53.8785C86.8664 53.8877 86.8581 53.899 86.8524 53.9116C86.8467 53.9243 86.8438 53.938 86.8438 53.9518C86.8438 53.9657 86.8467 53.9794 86.8524 53.992C86.8581 54.0047 86.8664 54.0159 86.8768 54.0251C87.2583 54.3399 87.7097 54.5586 88.1932 54.6628C88.6767 54.7669 89.1781 54.7534 89.6553 54.6236Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2037 49.2069C85.2354 49.2 85.265 49.1859 85.2904 49.1658C85.3158 49.1457 85.3363 49.1201 85.3503 49.0909C85.45 48.8432 85.6081 48.6233 85.8112 48.45C86.0143 48.2767 86.2564 48.155 86.5167 48.0955C86.5725 48.0865 86.6225 48.0558 86.6557 48.01C86.6889 47.9642 86.7026 47.9071 86.6938 47.8513C86.6847 47.795 86.6542 47.7445 86.6086 47.7103C86.5631 47.6762 86.506 47.661 86.4495 47.6681C86.1197 47.7331 85.8111 47.8786 85.5512 48.0917C85.2912 48.3048 85.088 48.5788 84.9595 48.8894C84.9367 48.9421 84.9354 49.0017 84.9559 49.0553C84.9765 49.1089 85.0172 49.1524 85.0694 49.1764C85.1094 49.2016 85.1568 49.2124 85.2037 49.2069Z",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2138 47.5521C92.2463 47.5442 92.276 47.5273 92.2993 47.5033C92.3194 47.4839 92.3354 47.4607 92.3464 47.435C92.3573 47.4092 92.3629 47.3816 92.3629 47.3537C92.3629 47.3257 92.3573 47.2981 92.3464 47.2724C92.3354 47.2466 92.3194 47.2234 92.2993 47.204C92.0761 46.9416 91.7934 46.7364 91.4746 46.6057C91.1559 46.475 90.8104 46.4226 90.4673 46.4529C90.4393 46.4566 90.4123 46.4659 90.3881 46.4804C90.3638 46.4948 90.3427 46.5141 90.3262 46.5369C90.3096 46.5598 90.2978 46.5858 90.2917 46.6134C90.2855 46.6409 90.285 46.6694 90.2902 46.6972C90.2939 46.7254 90.3033 46.7525 90.3176 46.7771C90.332 46.8016 90.3511 46.8231 90.3738 46.8401C90.3966 46.8572 90.4225 46.8695 90.4501 46.8764C90.4777 46.8834 90.5064 46.8847 90.5345 46.8804C90.8059 46.8601 91.0784 46.9049 91.329 47.0111C91.5797 47.1174 91.8014 47.2819 91.9756 47.4911C92.0047 47.5238 92.0429 47.5471 92.0854 47.558C92.1278 47.5689 92.1725 47.5668 92.2138 47.5521Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6945 70.3297L76.8011 72.8578C76.8011 72.8578 72.2944 85.8649 71.9646 87.935C74.4378 88.851 77.1552 92.5333 80.4528 94.9393C80.3673 95.6843 78.9384 97.5163 78.3643 97.9132C73.4424 95.5256 65.8947 92.2219 65.5405 89.364C64.6734 82.9521 70.6945 70.3297 70.6945 70.3297Z",
    fill: "#B55B52"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9814 94.6523H84.0926L82.6331 99.6842C82.6331 99.6842 79.476 99.4949 77.6074 97.1805L78.9814 94.6523Z",
    fill: "#B55B52"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1517 95.6599L85.6006 100.148L82.6328 99.7208L84.0923 94.689L87.1517 95.6599Z",
    fill: "#B55B52"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4302 65.1757C69.1556 65.7863 64.6001 80.6742 64.6001 80.6742L74.45 84.4054C76.3241 80.8556 77.9562 77.1832 79.3353 73.4135C81.2833 67.9359 78.0163 64.5039 73.4302 65.1757Z",
    fill: "url(#paint5_linear_1660_3857)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1817 215.148C70.488 215.173 70.7939 215.094 71.0488 214.922C71.1307 214.853 71.193 214.763 71.2295 214.663C71.2659 214.562 71.2752 214.453 71.2564 214.348C71.2559 214.285 71.2379 214.224 71.2044 214.171C71.171 214.118 71.1234 214.076 71.0671 214.049C70.5664 213.792 69.1191 214.69 68.9542 214.794C68.9357 214.805 68.921 214.821 68.9123 214.841C68.9035 214.86 68.9011 214.882 68.9054 214.904C68.912 214.923 68.9231 214.942 68.938 214.956C68.9528 214.971 68.9709 214.982 68.9909 214.989C69.3809 215.085 69.7802 215.138 70.1817 215.148ZM70.8351 214.213C70.8813 214.203 70.9293 214.203 70.9755 214.213C70.9969 214.227 71.0143 214.246 71.026 214.269C71.0378 214.291 71.0436 214.316 71.0427 214.342C71.0552 214.413 71.0494 214.486 71.0259 214.554C71.0024 214.623 70.962 214.684 70.9083 214.733C70.4003 214.962 69.8243 214.99 69.2962 214.812C69.7645 214.513 70.2876 214.309 70.8351 214.213Z",
    fill: "url(#paint6_linear_1660_3857)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0151 214.989C69.0308 214.995 69.0483 214.995 69.064 214.989C69.5281 214.733 70.4135 213.768 70.2853 213.236C70.2674 213.157 70.2233 213.086 70.1601 213.035C70.097 212.984 70.0184 212.956 69.9372 212.956C69.8567 212.943 69.7744 212.949 69.6963 212.972C69.6182 212.996 69.5462 213.036 69.4853 213.09C68.9663 213.523 68.8747 214.83 68.8747 214.885C68.8735 214.905 68.8781 214.925 68.8878 214.942C68.8976 214.959 68.9121 214.974 68.9296 214.983C68.9421 214.991 68.9566 214.996 68.9716 214.997C68.9866 214.999 69.0016 214.996 69.0151 214.989ZM69.8884 213.157H69.9372C70.0777 213.157 70.0899 213.236 70.096 213.261C70.1571 213.56 69.6014 214.311 69.1434 214.665C69.1604 214.151 69.3353 213.654 69.6441 213.243C69.7115 213.183 69.7985 213.15 69.8884 213.151V213.157Z",
    fill: "url(#paint7_linear_1660_3857)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4532 215.148C97.8402 215.184 98.2279 215.087 98.5524 214.873C98.6224 214.806 98.6754 214.724 98.7073 214.632C98.7391 214.541 98.7489 214.444 98.7356 214.348C98.7322 214.288 98.7136 214.231 98.6815 214.18C98.6494 214.13 98.605 214.089 98.5524 214.061C97.9967 213.755 96.1953 214.671 95.9938 214.787C95.9734 214.797 95.9568 214.813 95.9468 214.833C95.9368 214.853 95.934 214.876 95.9388 214.897C95.942 214.92 95.9519 214.94 95.9672 214.957C95.9825 214.973 96.0024 214.984 96.0243 214.989C96.4949 215.084 96.9731 215.138 97.4532 215.148ZM98.2532 214.213C98.3223 214.21 98.3912 214.223 98.4547 214.25C98.4751 214.262 98.492 214.279 98.5038 214.299C98.5156 214.319 98.5218 214.343 98.5219 214.366C98.5325 214.429 98.5275 214.494 98.5073 214.555C98.487 214.615 98.4522 214.67 98.4059 214.714C98.1311 214.958 97.3861 215.001 96.3785 214.836C96.9634 214.523 97.5974 214.313 98.2532 214.213Z",
    fill: "url(#paint8_linear_1660_3857)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0428 214.989H96.0916C96.629 214.739 97.6916 213.768 97.5939 213.249C97.5939 213.127 97.484 212.974 97.1908 212.95C97.0818 212.932 96.9703 212.939 96.8645 212.971C96.7588 213.003 96.6616 213.058 96.5802 213.133C96.0123 213.603 95.9207 214.824 95.9146 214.879C95.915 214.898 95.9196 214.917 95.9281 214.933C95.9365 214.95 95.9486 214.965 95.9634 214.977C95.9876 214.99 96.0157 214.995 96.0428 214.989ZM97.1053 213.157H97.1725C97.3679 213.157 97.3801 213.249 97.3862 213.273C97.4412 213.585 96.7206 214.354 96.1649 214.69C96.2019 214.175 96.4007 213.686 96.7328 213.291C96.8357 213.201 96.9682 213.151 97.1053 213.151V213.157Z",
    fill: "url(#paint9_linear_1660_3857)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M175.673 51.7352H172.821V52.3459H175.673V51.7352Z",
    fill: "url(#paint10_linear_1660_3857)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M170.281 51.7352H158.525V52.3459H170.281V51.7352Z",
    fill: "url(#paint11_linear_1660_3857)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M195.348 160.989H121.513C119.885 160.96 118.326 160.328 117.137 159.216C115.948 158.103 115.214 156.59 115.077 154.967L108.543 59.8937C108.48 59.1222 108.579 58.346 108.833 57.6147C109.086 56.8834 109.49 56.2131 110.018 55.6466C110.545 55.08 111.185 54.6296 111.896 54.3242C112.607 54.0187 113.375 53.8649 114.149 53.8726H187.977C189.606 53.8988 191.167 54.5296 192.356 55.6424C193.546 56.7552 194.279 58.2704 194.414 59.8937L200.948 154.967C201.013 155.739 200.915 156.515 200.663 157.247C200.41 157.979 200.007 158.649 199.479 159.216C198.952 159.783 198.312 160.234 197.601 160.539C196.89 160.844 196.122 160.997 195.348 160.989Z",
    fill: "url(#paint12_linear_1660_3857)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M121.372 158.979C120.289 158.96 119.252 158.539 118.462 157.797C117.672 157.056 117.185 156.047 117.098 154.967L110.545 59.8936C110.502 59.379 110.567 58.861 110.735 58.3729C110.904 57.8848 111.173 57.4374 111.525 57.0595C111.877 56.6816 112.304 56.3816 112.779 56.1787C113.254 55.9758 113.766 55.8746 114.283 55.8816H188.118C189.2 55.9021 190.237 56.3238 191.027 57.065C191.817 57.8062 192.303 58.8142 192.392 59.8936L198.932 154.967C198.976 155.482 198.911 156 198.742 156.488C198.574 156.976 198.305 157.424 197.953 157.801C197.601 158.179 197.173 158.479 196.699 158.682C196.224 158.885 195.711 158.986 195.195 158.979H121.372Z",
    fill: "#263238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.159 102.945H124.029L121.507 66.1895H188.631L191.159 102.945ZM124.499 102.444H190.621L188.179 66.6902H122.038L124.499 102.444Z",
    fill: "url(#paint13_linear_1660_3857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.771 71.8685H122.148L122.111 71.3678H188.734L188.771 71.8685Z",
    fill: "url(#paint14_linear_1660_3857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.125 77.047H122.502L122.466 76.5463H189.095L189.125 77.047Z",
    fill: "url(#paint15_linear_1660_3857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.486 82.2315H122.856L122.82 81.7246H189.449L189.486 82.2315Z",
    fill: "url(#paint16_linear_1660_3857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.839 87.4098H123.216L123.18 86.903H189.803L189.839 87.4098Z",
    fill: "url(#paint17_linear_1660_3857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.194 92.5883H123.571L123.534 92.0875H190.163L190.194 92.5883Z",
    fill: "url(#paint18_linear_1660_3857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.554 97.7666H123.925L123.889 97.2659H190.518L190.554 97.7666Z",
    fill: "url(#paint19_linear_1660_3857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.548 69.2794H115.394L115.357 68.7787H120.511L120.548 69.2794Z",
    fill: "url(#paint20_linear_1660_3857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.902 74.4578H115.748L115.711 73.957H120.872L120.902 74.4578Z",
    fill: "url(#paint21_linear_1660_3857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.256 79.6362H116.102L116.072 79.1355H121.226L121.256 79.6362Z",
    fill: "url(#paint22_linear_1660_3857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.617 84.8207H116.463L116.426 84.3138H121.58L121.617 84.8207Z",
    fill: "url(#paint23_linear_1660_3857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.971 89.999H116.817L116.78 89.4983H121.94L121.971 89.999Z",
    fill: "url(#paint24_linear_1660_3857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.325 95.1775H117.171L117.141 94.6768H122.295L122.325 95.1775Z",
    fill: "url(#paint25_linear_1660_3857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.685 100.356H117.531L117.495 99.8551H122.649L122.685 100.356Z",
    fill: "url(#paint26_linear_1660_3857)"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M124.408 102.909L124.127 102.475L132.072 97.6691L134.533 95.2081L139.955 90.4267L145.567 92.5212L151.252 83.0316L159.099 85.0895L169.169 78.4455L174.207 80.5706L187.416 73.9816L187.666 74.4335L174.256 81.1202L169.249 79.0134L159.215 85.633L151.515 83.6056L145.805 93.138L140.09 91.0007L134.887 95.5867L132.377 98.0904L124.408 102.909Z",
    fill: "#C9DDF1"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M124.456 102.866L124.072 102.524L131.748 93.7975L133.94 88.8268L141.329 93.0831L144.645 84.9796L151.063 79.0806L159.234 83.685L168.888 74.4885L175.776 78.586L186.933 67.8445L187.293 68.217L175.874 79.2089L168.986 75.1113L159.337 84.3079L151.161 79.6974L145.036 85.3216L141.598 93.7975L134.19 89.5351L132.163 94.1151L124.456 102.866Z",
    fill: "url(#paint27_linear_1660_3857)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M144.438 129.289L149.933 110.725C153.847 112.118 157.275 114.611 159.807 117.903C162.34 121.196 163.869 125.149 164.211 129.289C164.589 133.817 163.262 138.324 160.49 141.924C157.717 145.525 153.7 147.959 149.225 148.751L144.438 129.289Z",
    fill: "#C9DDF1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M144.438 129.289L149.207 148.751C148.08 148.949 146.938 149.049 145.793 149.05C134.96 149.05 125.428 140.128 124.683 129.289C124.484 126.759 124.813 124.216 125.649 121.819C126.485 119.423 127.809 117.227 129.538 115.37C131.268 113.513 133.364 112.035 135.694 111.03C138.025 110.026 140.538 109.516 143.076 109.534C145.407 109.538 147.72 109.941 149.915 110.725L144.438 129.289Z",
    fill: "url(#paint28_linear_1660_3857)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M177.743 127.659H171.88L173.352 149.05H179.214L177.743 127.659Z",
    fill: "#C9DDF1"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M177.743 127.659H171.881L170.983 114.621H176.845L177.743 127.659Z",
    fill: "url(#paint29_linear_1660_3857)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M187.983 131.555H182.121L183.324 149.05H189.186L187.983 131.555Z",
    fill: "#C9DDF1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M187.984 131.555H182.121L181.572 123.537H187.434L187.984 131.555Z",
    fill: "url(#paint30_linear_1660_3857)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M221.606 62.9407C220.996 65.9329 220.434 71.4227 222.528 73.4196C220.832 76.1702 218.304 78.309 215.31 79.5262C211.304 77.0164 213.222 73.4196 213.222 73.4196C216.562 72.6196 216.477 70.1465 215.89 67.8198L221.606 62.9407Z",
    fill: "#FF8B7B"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M223.603 75.1906C225.783 73.6884 225.942 70.8366 225.942 70.8366C225.942 70.8366 218.004 68.8031 213.68 70.0244C212.355 71.0381 210.242 72.9251 210.242 72.9251C210.242 72.9251 210.78 74.1464 213.222 74.9158C215.665 75.6852 223.603 75.1906 223.603 75.1906Z",
    fill: "#263238"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M232.83 77.505C234.32 79.6545 235.658 81.7796 236.928 84.033C238.226 86.2689 239.4 88.5746 240.445 90.9395C240.702 91.5502 240.964 92.1609 241.196 92.7715L241.373 93.2356L241.465 93.4677L241.508 93.5837L241.581 93.7974C241.763 94.3587 241.839 94.9487 241.807 95.5378C241.739 96.4511 241.49 97.3418 241.074 98.1575C240.742 98.8313 240.345 99.4714 239.889 100.069C238.23 102.187 236.238 104.023 233.991 105.504L232.33 103.562C233.883 101.788 235.268 99.8723 236.464 97.84C236.702 97.3942 236.907 96.9308 237.074 96.4538C237.2 96.1335 237.254 95.7896 237.233 95.4462C237.233 95.3546 237.196 95.318 237.178 95.3302L237.135 95.2325L237.038 95.031L236.855 94.6218C236.61 94.0844 236.329 93.5532 236.067 93.0158C235.525 91.941 234.949 90.8744 234.339 89.8159C233.728 88.7534 233.117 87.6969 232.507 86.6527C231.23 84.5703 229.899 82.4575 228.58 80.4545L232.83 77.505Z",
    fill: "#FF8B7B"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M233.209 103.037L227.774 102.628L230.778 106.786C230.778 106.786 233.997 106.389 234.754 104.435L233.209 103.037Z",
    fill: "#FF8B7B"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M224.245 104.985L226.956 108.331L231.585 106.627L227.774 102.628L224.245 104.985Z",
    fill: "#FF8B7B"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M230.833 74.5005L227.377 79.2148L227.627 85.0344L233.496 90.3593C233.496 90.3593 236.506 88.2159 239.126 86.0481C235.841 78.5186 232.873 75.1111 230.833 74.5005Z",
    fill: "url(#paint31_linear_1660_3857)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M229.581 78.9706L227.75 85.1138L229.722 86.9031C229.435 82.604 229.581 78.9706 229.581 78.9706Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M204.099 78.0913C204.02 81.7552 204.532 89.3579 207.103 105.174H227.597C227.255 96.8324 226.846 91.6052 230.834 74.4823C228.095 73.9245 225.319 73.5694 222.529 73.4197C219.43 73.1996 216.32 73.1996 213.222 73.4197C211.219 73.6029 209.076 73.9266 207.445 74.2075C206.523 74.3649 205.684 74.8387 205.074 75.5475C204.463 76.2563 204.118 77.1558 204.099 78.0913Z",
    fill: "url(#paint32_linear_1660_3857)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M208.105 79.514L204.441 85.4558C204.63 87.5686 204.911 90.1029 205.308 93.1318L208.294 91.3608C209.528 82.3719 208.105 79.514 208.105 79.514Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M208.703 81.1018C207.878 83.9414 206.999 86.7626 206.089 89.5717C205.179 92.3807 204.257 95.1959 203.311 97.9927L203.128 98.5179L202.834 99.2018C202.637 99.6219 202.415 100.03 202.169 100.423C201.689 101.178 201.128 101.879 200.496 102.512C199.302 103.695 197.932 104.685 196.435 105.449C193.609 106.866 190.544 107.746 187.397 108.044L186.976 105.522C188.306 105.115 189.609 104.623 190.878 104.05C192.125 103.502 193.319 102.84 194.444 102.072C195.508 101.378 196.464 100.532 197.284 99.5621C197.66 99.121 197.984 98.6373 198.248 98.1209C198.38 97.8811 198.494 97.6321 198.59 97.3759L198.712 97.0339L198.859 96.5088C199.616 93.6692 200.398 90.848 201.228 88.0328C202.059 85.2177 202.865 82.4086 203.763 79.6179L208.703 81.1018Z",
    fill: "#FF8B7B"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M209.326 78.3172C208.465 76.2531 205.754 74.9158 205.754 74.9158C202.841 76.8149 201.638 78.7996 199.702 88.448C202.804 89.8403 207.421 89.8281 207.421 89.8281L209.937 83.3368C209.937 83.3368 210.193 80.3812 209.326 78.3172Z",
    fill: "url(#paint33_linear_1660_3857)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M188.026 105.253L182.933 105.174L186.176 109.149C186.176 109.149 189.363 108.539 190.005 106.566L188.026 105.253Z",
    fill: "#FF8B7B"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M179.55 107.733L182.445 110.914L186.176 109.149L182.933 105.174L179.55 107.733Z",
    fill: "#FF8B7B"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M210.944 56.6998C210.877 57.0967 210.602 57.3837 210.333 57.341C210.065 57.2982 209.918 56.9318 209.991 56.5288C210.065 56.1258 210.333 55.8388 210.602 55.9181C210.871 55.9975 210.999 56.2968 210.944 56.6998Z",
    fill: "#263238"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M210.712 55.9304L209.796 55.4846C209.796 55.4846 210.157 56.3212 210.712 55.9304Z",
    fill: "#263238"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M210.774 54.1899C210.73 54.1718 210.693 54.1413 210.667 54.1022C210.641 54.0631 210.627 54.0171 210.627 53.9701C210.627 53.9231 210.641 53.8771 210.667 53.838C210.693 53.7989 210.73 53.7683 210.774 53.7503C211.112 53.5762 211.486 53.4854 211.867 53.4854C212.247 53.4854 212.622 53.5762 212.96 53.7503C213.013 53.7842 213.051 53.8376 213.066 53.8991C213.081 53.9606 213.071 54.0255 213.039 54.08C213.024 54.1073 213.003 54.1313 212.979 54.1505C212.954 54.1697 212.926 54.1837 212.895 54.1917C212.865 54.1997 212.834 54.2015 212.803 54.197C212.772 54.1925 212.742 54.1818 212.715 54.1655C212.448 54.0278 212.152 53.956 211.851 53.956C211.551 53.956 211.254 54.0278 210.987 54.1655C210.956 54.187 210.921 54.2005 210.883 54.2048C210.846 54.209 210.808 54.2039 210.774 54.1899Z",
    fill: "#263238"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M210.914 58.0127C210.396 58.8649 209.763 59.6416 209.033 60.321C209.211 60.5029 209.427 60.6436 209.665 60.7333C209.904 60.823 210.159 60.8594 210.413 60.8401L210.914 58.0127Z",
    fill: "#FF5652"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M224.763 57.4448C223.591 62.33 223.2 64.4002 220.263 66.4886C215.848 69.6274 210.126 67.0993 209.82 61.9942C209.552 57.3837 211.512 50.1962 216.678 49.0909C217.816 48.8418 218.999 48.8878 220.114 49.2243C221.229 49.5609 222.24 50.1769 223.05 51.0139C223.86 51.8509 224.442 52.8811 224.742 54.0066C225.042 55.1321 225.049 56.3156 224.763 57.4448Z",
    fill: "#FF8B7B"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M229.422 59.7485C229.897 55.624 226.938 51.896 222.813 51.4217C218.689 50.9474 214.961 53.9064 214.486 58.0309C214.012 62.1553 216.971 65.8834 221.095 66.3577C225.22 66.832 228.948 63.8729 229.422 59.7485Z",
    fill: "#263238"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M216.831 57.6585C222.327 54.0434 230.754 52.0771 228.922 46.459C227.445 41.934 220.684 41.7203 215.488 43.8393C208.361 46.7216 211.341 61.2676 216.831 57.6585Z",
    fill: "#263238"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M223.823 49.6345C223.775 49.6348 223.728 49.6233 223.685 49.6009C223.642 49.5785 223.606 49.546 223.579 49.5062L217.79 41.4516C217.755 41.3851 217.745 41.3082 217.762 41.2351C217.779 41.162 217.822 41.0975 217.883 41.0536C217.944 41.0098 218.019 40.9894 218.094 40.9963C218.169 41.0032 218.239 41.037 218.291 41.0913L224.074 49.152C224.12 49.2171 224.138 49.2977 224.126 49.3764C224.113 49.4551 224.07 49.5258 224.006 49.5734C223.954 49.6143 223.889 49.6359 223.823 49.6345Z",
    fill: "url(#paint34_linear_1660_3857)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M227.358 51.668C227.295 51.6677 227.234 51.6485 227.181 51.613C227.148 51.5899 227.12 51.5604 227.099 51.5263C227.077 51.4923 227.062 51.4543 227.056 51.4145C227.049 51.3748 227.05 51.3341 227.059 51.2948C227.068 51.2555 227.085 51.2184 227.108 51.1855L232.891 43.1309C232.938 43.0645 233.009 43.0195 233.09 43.0058C233.17 42.992 233.252 43.0107 233.318 43.0576C233.385 43.1046 233.43 43.176 233.444 43.2562C233.457 43.3364 233.439 43.4187 233.392 43.4851L227.603 51.5458C227.575 51.5841 227.538 51.6151 227.495 51.6364C227.453 51.6576 227.406 51.6684 227.358 51.668Z",
    fill: "url(#paint35_linear_1660_3857)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M230.328 60.1541C234.419 57.612 236.073 52.8784 234.024 49.5814C231.975 46.2844 226.998 45.6724 222.908 48.2146C218.817 50.7567 217.163 55.4903 219.212 58.7873C221.261 62.0843 226.238 62.6962 230.328 60.1541Z",
    fill: "#263238"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M207.103 105.174C207.103 105.174 208.831 143.175 209.167 158.564C209.509 174.576 209.662 211.96 209.662 211.96H213.704C213.704 211.96 220.147 180.89 218.241 158.564C221.124 141.423 223.072 105.174 223.072 105.174H207.103Z",
    fill: "#FF8B7B"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M212.458 105.174C212.458 105.174 222.082 144.971 226.021 159.853C230.155 175.479 235.737 210.8 235.792 211.96H239.285C239.285 211.96 240.384 171.156 234.858 157.282C234.858 139.896 227.621 105.174 227.621 105.174H212.458Z",
    fill: "#FF8B7B"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M236.958 210.983C239.938 210.488 239.932 211.942 240.183 213.505C240.363 214.444 240.223 215.415 239.786 216.265C238.79 218.012 239.786 220.595 236.421 220.595C233.056 220.595 232.727 219.862 233.581 218.299C234.377 216.721 234.917 215.026 235.181 213.279C235.352 212.375 235.633 211.203 236.958 210.983Z",
    fill: "#263238"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M239.999 213.927C240.072 215.942 240.268 220.595 240.268 220.595H239.737C239.737 220.595 239.126 215.636 238.766 214.299L239.999 213.927Z",
    fill: "#263238"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M216.214 59.1729C215.84 60.0636 215.129 60.7703 214.236 61.1392C213.014 61.6217 212.306 60.5896 212.52 59.3927C212.709 58.3119 213.564 56.7669 214.816 56.7974C215.089 56.8108 215.354 56.8919 215.588 57.0333C215.822 57.1748 216.017 57.3722 216.156 57.6078C216.295 57.8434 216.373 58.1098 216.383 58.383C216.393 58.6562 216.335 58.9277 216.214 59.1729Z",
    fill: "#FF8B7B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.125 156.677C209.125 157.337 209.155 157.966 209.167 158.564C209.222 161.007 209.271 164.017 209.314 167.29L218.571 165.092C218.529 162.863 218.419 160.671 218.242 158.564C218.425 157.459 218.608 156.274 218.791 155.022L209.125 156.677Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.815 157.282C234.815 155.749 234.754 154.082 234.65 152.311L224.495 154.045C225.056 156.231 225.563 158.198 226.003 159.853C226.272 160.866 226.544 161.957 226.821 163.126L235.981 160.952C235.668 159.706 235.278 158.48 234.815 157.282Z",
    fill: "black"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M207.103 105.174L207.714 165.691L236.415 159.584C236.867 125.051 234.174 113.107 227.609 105.174H207.103Z",
    fill: "#263238"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M226.431 120.111C226.431 120.111 220.849 124.752 214.01 126.291C221.136 125.747 224.751 123.744 226.431 120.111Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M206.328 101.37C206.388 102.672 206.516 103.97 206.712 105.259C206.749 105.626 206.853 108.423 206.969 109.058C207.085 109.693 230.522 109.32 230.058 108.349C229.594 107.378 228.085 105.394 228.085 104.966C228.085 104.539 227.927 101.382 227.731 101.119C227.536 100.857 206.444 100.38 206.328 101.37Z",
    fill: "url(#paint36_linear_1660_3857)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M206.328 101.37C206.388 102.672 206.516 103.97 206.712 105.259C206.749 105.626 206.853 108.423 206.969 109.058C207.085 109.693 230.522 109.32 230.058 108.349C229.594 107.378 228.085 105.394 228.085 104.966C228.085 104.539 227.927 101.382 227.731 101.119C227.536 100.857 206.444 100.38 206.328 101.37Z",
    fill: "#263238"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M209.643 210.489C208.593 213.511 205.552 218.897 205.552 218.897L211.323 217.303L214.156 212.852L213.545 211.679L209.643 210.489Z",
    fill: "#FF8B7B"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M214.406 211.343C214.653 211.859 214.77 212.427 214.748 212.998C214.712 215.068 214.48 220.571 214.48 220.571H213.997C214 218.878 213.914 217.186 213.741 215.502C213.497 214.134 212.904 216.546 211.988 217.902C211.072 219.258 209.277 220.497 206.114 220.571C202.413 220.662 200.917 220.497 201.992 219.6C203.067 218.702 205.503 218.128 205.503 218.128C206.507 218.101 207.487 217.811 208.345 217.287C209.202 216.763 209.907 216.024 210.388 215.142C211.488 213.157 212.831 211.185 213.741 210.721C213.893 210.765 214.032 210.845 214.148 210.953C214.263 211.061 214.352 211.195 214.406 211.343Z",
    fill: "#263238"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1660_3857",
    x1: 100.035,
    y1: 65.0237,
    x2: 100.035,
    y2: 84.5581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1660_3857",
    x1: 87.4621,
    y1: 64.0009,
    x2: 87.4621,
    y2: 106.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1660_3857",
    x1: 82.4373,
    y1: 78.4331,
    x2: 82.4373,
    y2: 80.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1660_3857",
    x1: 93.709,
    y1: 206.092,
    x2: 93.709,
    y2: 208.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1660_3857",
    x1: 67.6384,
    y1: 206.238,
    x2: 67.6384,
    y2: 208.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1660_3857",
    x1: 72.2548,
    y1: 65.092,
    x2: 72.2548,
    y2: 84.4054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1660_3857",
    x1: 70.0846,
    y1: 214.003,
    x2: 70.0846,
    y2: 215.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1660_3857",
    x1: 69.5862,
    y1: 212.949,
    x2: 69.5862,
    y2: 214.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1660_3857",
    x1: 97.3389,
    y1: 213.999,
    x2: 97.3389,
    y2: 215.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1660_3857",
    x1: 96.7574,
    y1: 212.94,
    x2: 96.7574,
    y2: 214.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1660_3857",
    x1: 174.247,
    y1: 51.7352,
    x2: 174.247,
    y2: 52.3459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1660_3857",
    x1: 164.403,
    y1: 51.7352,
    x2: 164.403,
    y2: 52.3459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1660_3857",
    x1: 154.746,
    y1: 53.8723,
    x2: 154.746,
    y2: 160.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1660_3857",
    x1: 156.333,
    y1: 66.1895,
    x2: 156.333,
    y2: 102.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1660_3857",
    x1: 155.441,
    y1: 71.3678,
    x2: 155.441,
    y2: 71.8685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1660_3857",
    x1: 155.796,
    y1: 76.5463,
    x2: 155.796,
    y2: 77.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1660_3857",
    x1: 156.153,
    y1: 81.7246,
    x2: 156.153,
    y2: 82.2315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1660_3857",
    x1: 156.51,
    y1: 86.903,
    x2: 156.51,
    y2: 87.4098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1660_3857",
    x1: 156.864,
    y1: 92.0875,
    x2: 156.864,
    y2: 92.5883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1660_3857",
    x1: 157.222,
    y1: 97.2659,
    x2: 157.222,
    y2: 97.7666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1660_3857",
    x1: 117.953,
    y1: 68.7787,
    x2: 117.953,
    y2: 69.2794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1660_3857",
    x1: 118.307,
    y1: 73.957,
    x2: 118.307,
    y2: 74.4578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1660_3857",
    x1: 118.664,
    y1: 79.1355,
    x2: 118.664,
    y2: 79.6362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1660_3857",
    x1: 119.022,
    y1: 84.3138,
    x2: 119.022,
    y2: 84.8207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1660_3857",
    x1: 119.376,
    y1: 89.4983,
    x2: 119.376,
    y2: 89.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1660_3857",
    x1: 119.733,
    y1: 94.6768,
    x2: 119.733,
    y2: 95.1775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1660_3857",
    x1: 120.09,
    y1: 99.8551,
    x2: 120.09,
    y2: 100.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1660_3857",
    x1: 155.683,
    y1: 67.8445,
    x2: 155.683,
    y2: 102.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1660_3857",
    x1: 137.271,
    y1: 109.534,
    x2: 137.271,
    y2: 149.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1660_3857",
    x1: 174.363,
    y1: 114.621,
    x2: 174.363,
    y2: 127.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1660_3857",
    x1: 184.778,
    y1: 123.537,
    x2: 184.778,
    y2: 131.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1660_3857",
    x1: 233.251,
    y1: 74.5005,
    x2: 233.251,
    y2: 90.3593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1660_3857",
    x1: 217.462,
    y1: 73.2546,
    x2: 217.462,
    y2: 105.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1660_3857",
    x1: 204.837,
    y1: 74.9158,
    x2: 204.837,
    y2: 89.8281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1660_3857",
    x1: 220.942,
    y1: 40.995,
    x2: 220.942,
    y2: 49.6345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1660_3857",
    x1: 230.25,
    y1: 43.0013,
    x2: 230.25,
    y2: 51.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1660_3857",
    x1: 218.196,
    y1: 100.771,
    x2: 218.196,
    y2: 109.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataReport);
export default __webpack_public_path__ + "static/media/DataReport.d7537c91ef044bd62cc3010668a37b49.svg";
export { ForwardRef as ReactComponent };